module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "calendar_opel.1a4eaf77.svg";